export default "__VITE_ASSET__CUX7QFMZ__"